// variables
import { StyledDrawingIcon } from 'variables';

// libraries
import styled from 'styled-components';

export const StyledCaptureIcon = styled.svg`
  ${StyledDrawingIcon}

  .${(props) => props.pathName} {
    transition: all 0.3s ease;
    fill: ${(props) => (props.$isSelected ? '#2563EB' : '#4C4D56')};
  }

  &:hover {
    .${(props) => props.pathName} {
      fill: #1e40af;
    }
    path {
      fill: #e3e5eb;
    }
    border-radius: 4px;
  }

  &:active {
    .${(props) => props.pathName} {
      fill: #1e40af;
    }
    background: #c1c4ce;
  }
`;
